import * as actionTypes from 'modules/steps/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isReady = (state, { payload = false }) => payload;

export default createReducer(initialState, {
  [actionTypes.SET_STEPS_DETAILS_READY]: isReady,
});
